// Re-export from stores for backward compatibility
import useCaminoStore from "stores/caminoStore";

export default useCaminoStore;
